import BaseElement from './BaseElement';
import CroppingAvatar from '../Components/CroppingAvatar';
class AvatarSelector extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = CroppingAvatar;
    }
}
export default AvatarSelector;
